import { createRouter, createWebHistory } from "vue-router";
import { defaultTitle } from "../assets/scripts/config";
import List from "../views/UnitList.vue";
import UnitTitlesJson from "@/assets/json/unit_titles.json";
import LearningUnit01 from "../assets/json/learning_unit_01.json";
import LearningUnit02 from "../assets/json/learning_unit_02.json";
import LearningUnit03 from "../assets/json/learning_unit_03.json";
import LearningUnit04 from "../assets/json/learning_unit_04.json";
import LearningUnit05 from "../assets/json/learning_unit_05.json";
import LearningUnit06 from "../assets/json/learning_unit_06.json";
import LearningUnit07 from "../assets/json/learning_unit_07.json";
import LearningUnit08 from "../assets/json/learning_unit_08.json";
import LearningUnit09 from "../assets/json/learning_unit_09.json";
import LearningUnit10 from "../assets/json/learning_unit_10.json";
import LearningUnit11 from "../assets/json/learning_unit_11.json";
import LearningUnit12 from "../assets/json/learning_unit_12.json";
import LearningUnit13 from "../assets/json/learning_unit_13.json";
import LearningUnit14 from "../assets/json/learning_unit_14.json";
import LearningUnit15 from "../assets/json/learning_unit_15.json";
import LearningUnit16 from "../assets/json/learning_unit_16.json";
import LearningUnit17 from "../assets/json/learning_unit_17.json";
import LearningUnit18 from "../assets/json/learning_unit_18.json";
import LearningUnit19 from "../assets/json/learning_unit_19.json";
import LearningUnit20 from "../assets/json/learning_unit_20.json";
import LearningUnit21 from "../assets/json/learning_unit_21.json";
import LearningUnit22 from "../assets/json/learning_unit_22.json";
import LearningUnit23 from "../assets/json/learning_unit_23.json";
import LearningUnit24 from "../assets/json/learning_unit_24.json";
import LearningUnit25 from "../assets/json/learning_unit_25.json";
import store from "@/store/index.js";

const { unit_titles } = UnitTitlesJson;

const getUnitTitle = (unitTitles) => {
  const sideMenuTitle = unitTitles.side_menu_title;
  console.log(sideMenuTitle);
  const hasSideMenuTitle = !(
    sideMenuTitle === undefined || sideMenuTitle === ""
  );
  console.log(hasSideMenuTitle);
  return hasSideMenuTitle ? unitTitles.side_menu_title : unitTitles.title;
};

const routes = [
  {
    path: "/",
    name: "List",
    component: List,
    meta: { title: "NEW HORIZON English Course 3ホーム" },
    props: {
      unitTitlesJson: UnitTitlesJson,
    },
  },
  {
    path: "/a/",
    name: "a",
    component: () =>
      import(/* webpackChunkName: "A" */ "../views/LearningUnit.vue"),
    meta: { title: "巻頭資料" },
    props: {
      unitTitle: getUnitTitle(unit_titles[0]),
      learningUnitJson: LearningUnit01,
    },
  },
  {
    path: "/b/",
    name: "b",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 0 Discover a new side of classmates" },
    props: {
      unitTitle: getUnitTitle(unit_titles[1]),
      learningUnitJson: LearningUnit02,
    },
  },
  {
    path: "/c/",
    name: "c",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 1 What is special about Japanese pop culture?" },
    props: {
      unitTitle: getUnitTitle(unit_titles[2]),
      learningUnitJson: LearningUnit03,
    },
  },
  {
    path: "/d/",
    name: "d",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 1 ディスカッション" },
    props: {
      unitTitle: getUnitTitle(unit_titles[3]),
      learningUnitJson: LearningUnit04,
    },
  },
  {
    path: "/e/",
    name: "e",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Learning Japanese in English" },
    props: {
      unitTitle: getUnitTitle(unit_titles[4]),
      learningUnitJson: LearningUnit05,
    },
  },
  {
    path: "/f/",
    name: "f",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 2 How do you choose your clothes?" },
    props: {
      unitTitle: getUnitTitle(unit_titles[5]),
      learningUnitJson: LearningUnit06,
    },
  },
  {
    path: "/g/",
    name: "g",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 2 講演" },
    props: {
      unitTitle: getUnitTitle(unit_titles[6]),
      learningUnitJson: LearningUnit07,
    },
  },
  {
    path: "/h/",
    name: "h",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 3 How can we save animals?" },
    props: {
      unitTitle: getUnitTitle(unit_titles[7]),
      learningUnitJson: LearningUnit08,
    },
  },
  {
    path: "/i/",
    name: "i",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 3　グラフや表の活用−レポート−" },
    props: {
      unitTitle: getUnitTitle(unit_titles[8]),
      learningUnitJson: LearningUnit09,
    },
  },
  {
    path: "/j/",
    name: "j",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Learning Science in English" },
    props: {
      unitTitle: getUnitTitle(unit_titles[9]),
      learningUnitJson: LearningUnit10,
    },
  },
  {
    path: "/k/",
    name: "k",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Stage Activity 1 My Favorite Japanese Food" },
    props: {
      unitTitle: getUnitTitle(unit_titles[10]),
      learningUnitJson: LearningUnit11,
    },
  },
  {
    path: "/l/",
    name: "l",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Let's Read 1 A Mother's Lullaby" },
    props: {
      unitTitle: getUnitTitle(unit_titles[11]),
      learningUnitJson: LearningUnit12,
    },
  },
  {
    path: "/m/",
    name: "m",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 4 How do we help each other in a disaster?" },
    props: {
      unitTitle: getUnitTitle(unit_titles[12]),
      learningUnitJson: LearningUnit13,
    },
  },
  {
    path: "/n/",
    name: "n",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 4 町中での手助け−申し出る−" },
    props: {
      unitTitle: getUnitTitle(unit_titles[13]),
      learningUnitJson: LearningUnit14,
    },
  },
  {
    path: "/o/",
    name: "o",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Learning Art in English" },
    props: {
      unitTitle: getUnitTitle(unit_titles[14]),
      learningUnitJson: LearningUnit15,
    },
  },
  {
    path: "/p/",
    name: "p",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 5 What makes a good leader?" },
    props: {
      unitTitle: getUnitTitle(unit_titles[15]),
      learningUnitJson: LearningUnit16,
    },
  },
  {
    path: "/q/",
    name: "q",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 5 記事への意見−投稿文−" },
    props: {
      unitTitle: getUnitTitle(unit_titles[16]),
      learningUnitJson: LearningUnit17,
    },
  },
  {
    path: "/r/",
    name: "r",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Stage Activity 2 My Activity Report" },
    props: {
      unitTitle: getUnitTitle(unit_titles[17]),
      learningUnitJson: LearningUnit18,
    },
  },
  {
    path: "/s/",
    name: "s",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Unit 6 What does it mean to be a global citizen?" },
    props: {
      unitTitle: getUnitTitle(unit_titles[18]),
      learningUnitJson: LearningUnit19,
    },
  },
  {
    path: "/t/",
    name: "t",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Real Life English 6 テレビの国際ニュース" },
    props: {
      unitTitle: getUnitTitle(unit_titles[19]),
      learningUnitJson: LearningUnit20,
    },
  },
  {
    path: "/u/",
    name: "u",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Learning Social Studies in English" },
    props: {
      unitTitle: getUnitTitle(unit_titles[20]),
      learningUnitJson: LearningUnit21,
    },
  },
  {
    path: "/v/",
    name: "v",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Stage Activity 3 Let's Have a mini Debate" },
    props: {
      unitTitle: getUnitTitle(unit_titles[21]),
      learningUnitJson: LearningUnit22,
    },
  },
  {
    path: "/w/",
    name: "w",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Let's Read 2 Power Your Future" },
    props: {
      unitTitle: getUnitTitle(unit_titles[22]),
      learningUnitJson: LearningUnit23,
    },
  },
  {
    path: "/x/",
    name: "x",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "Let's Read 3 Coloring Outside the Lines" },
    props: {
      unitTitle: getUnitTitle(unit_titles[23]),
      learningUnitJson: LearningUnit24,
    },
  },
  {
    path: "/y/",
    name: "y",
    component: () =>
      import(/* webpackChunkName: "B" */ "../views/LearningUnit.vue"),
    meta: { title: "資料編" },
    props: {
      unitTitle: getUnitTitle(unit_titles[24]),
      learningUnitJson: LearningUnit25,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || defaultTitle;
});

router.beforeEach(() =>{
  store.commit(
    "toggleDarkMode",
    localStorage.getItem("darkModeFrag") === "true"
  );
});

export default router;
